<form *ngIf="workerGuardShiftFormGroup" [formGroup]="workerGuardShiftFormGroup">
    <div class="card mt-2 ">        
        <div class="input-field ">
            <label for="startHour">Turno de guardia</label>
            <p-dropdown [options]="guardShifts" formControlName="guardShiftId" [required]="true"
                            optionValue="id" [filter]="true" filterBy="name" optionLabel="name" appendTo="body"
                            placeholder="Seleccione turno" />
        </div>
        <div class="mt-6 flex gap-2 justify-content-end ">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </div>
</form>